const successMessage = (message) => {
    window.vm.$toast.success({
        title: 'Success',
        message: message,
        color: '#D6E09B'
    })
}

export default successMessage
